var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccoTileMobile = function SvgAccoTileMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 359 528"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#acco-tile-mobile_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 512,
    x: 8,
    y: 6,
    fill: "#fff",
    rx: 4,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#acco-tile-mobile_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 257,
    x: 8,
    y: 6,
    fill: "#EDEDED",
    rx: 4
  })), /*#__PURE__*/React.createElement("rect", {
    width: 311,
    height: 18,
    x: 24,
    y: 279,
    fill: "#EDEDED",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 24,
    x: 24,
    y: 305,
    fill: "#EDEDED",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M101.526 324.11v-11.928h.994v11.928h-.994Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 24,
    x: 113,
    y: 305,
    fill: "#EDEDED",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M24 337h311v24H24z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 311,
    height: 24,
    x: 24,
    y: 337,
    fill: "#EDEDED",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M24 369h311v24H24zM24 401h311v14H24zM24 423h311v15H24z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 311,
    height: 48,
    x: 24,
    y: 454,
    fill: "#EDEDED",
    rx: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "acco-tile-mobile_svg__b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 257,
    x: 8,
    y: 6,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "acco-tile-mobile_svg__a",
    width: 359,
    height: 528,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3289_13164"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3289_13164",
    result: "shape"
  })))));
};
export default SvgAccoTileMobile;